export const FILL_GLOSSARY = 'FILL_GLOSSARY';
export const FILL_COMMON_DATA = 'FILL_COMMON_DATA';
export const FILL_SELECTED = 'FILL_SELECTED';
export const FILL_MODULES = 'FILL_MODULES';
export const SET_TOPIC = 'SET_TOPIC';
export const SET_ACT = 'SET_ACT';
export const SET_SELECTED_CONTENT = 'SET_SELECTED_CONTENT';
export const UPDATE_CONTENT = 'UPDATE_CONTENT';

export const FILL_COMMENTS = 'FILL_COMMENTS';
export const ADD_COMMENT = 'ADD_COMMENT';
export const REMOVE_COMMENT = 'REMOVE_COMMENT';

export const FILL_FAVORITES = 'FILL_FAVORITES';
export const ADD_FAVORITES = 'ADD_FAVORITES';
export const REMOVE_FAVORITES = 'REMOVE_FAVORITES';

export const FILL_START_PAGE = 'FILL_START_PAGE';
